import { render, staticRenderFns } from "./BarCodeGoodList.vue?vue&type=template&id=2d482c86&scoped=true"
import script from "./BarCodeGoodList.vue?vue&type=script&lang=ts"
export * from "./BarCodeGoodList.vue?vue&type=script&lang=ts"
import style0 from "./BarCodeGoodList.vue?vue&type=style&index=0&id=2d482c86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d482c86",
  null
  
)

export default component.exports